<template lang="pug">
.textarea
  Editor(:initialValue="value", :options="options", @change="emit", ref="editor", previewStyle="tab", initialEditType="wysiwyg", :height="`${height.includes('%') ? height : `${height}px`}`")
</template>

<script>

import 'codemirror/lib/codemirror.css';
import '@toast-ui/editor/dist/toastui-editor.css';

import { Editor } from '@toast-ui/vue-editor';

export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    toolbar: {
      type: Array,
      default: () => ['heading', 'bold', 'italic', 'ul', 'image', 'link'],
    },
    height: {
      type: String,
      default: '300',
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  components: {
    Editor,
  },
  computed: {
    options() {
      const { toolbar, placeholder } = this;
      return {
        hideModeSwitch: true,
        toolbarItems: toolbar,
        placeholder,
      };
    },
  },
  methods: {
    /**
     * Emit the value to parent
     */
    emit() {
      if (this.value !== this.$refs.editor.invoke('getMarkdown')) {
        this.$emit('newContent', true);
      }
      this.$emit('input', this.$refs.editor.invoke('getMarkdown'));
    },
  },
};
</script>

<style lang="scss" scoped>
</style>

<style lang="scss">
.textarea {
  .te-ww-container .tui-editor-contents:first-child {
    padding: 7px 7px 0 10px;
    font-family: Inter;
    font-weight: 400;
    font-size: 1rem;
  }

  .tui-editor {
    border-top: 1px solid #B6BDC7;
  }

  .tui-editor-defaultUI {
    border-radius: 5px;
    border-color: #B7BDC6;
  }

  .te-ww-container {
    border-radius: 0 0 4px 4px;
    border-left: 2px solid #E9EBED;
    border-top: 2px solid #E9EBED;
  }

  .te-toolbar-section, .te-markdown-tab-section {
    height: auto;
  }

  .tui-editor-defaultUI-toolbar {
    align-items: center;
    display: flex;
    padding: 0;
    height: auto;
    border-bottom: 1px solid #E9EBED;

    button {
      background: none;
      border: 0;
      margin: 0;
      padding: 10px;
      float: none;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      outline: none;
      width: auto;
      height: auto;
      border-right: 1px solid #E9EBED;

      &.tui-bold {
        &:before {
          content: "\F264";
        }
      }

      &.tui-link {
        &:before {
          content: "\F337";
        }
      }

      &.tui-ul {
        &:before {
          content: "\F279";
        }
      }

      &:before {
        color: black;
        font-size: 2rem;
        display: inline-block;
        font: normal normal normal 24px/1 "Material Design Icons";
        font-size: 24px;
        text-rendering: auto;
        line-height: inherit;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
      }
    }
  }
}
</style>
